const generateJobUrl = (job: { name: string; address: { state: string; city: string; }; code: any; }) => {
	const jobName = job.name?.toLowerCase();
	const jobState = job.address?.state?.trim();
	const jobCity = job.address?.city?.toLowerCase();

	const urlSegment = [jobName, jobState, jobCity]
		.flatMap(val => val ? val.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9-]/g, " ").trim().split(/\s+/).join("-") : [])
		.join('-');

	return `/vaga-pcd/${urlSegment}/${job.code}`;
};

export default generateJobUrl;